function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_9652:359)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.0312 13.0625C15.3765 13.0625 14.8438 12.5298 14.8438 11.875V7.71875C14.8438 6.28789 14.2855 4.9436 13.2719 3.93352C12.647 3.31082 11.8956 2.86188 11.0759 2.61013C11.2068 2.36238 11.2812 2.08043 11.2812 1.78125C11.2812 0.799076 10.4822 0 9.5 0C8.51783 0 7.71875 0.799076 7.71875 1.78125C7.71875 2.08213 7.79401 2.36569 7.9263 2.61447C5.74631 3.29539 4.15625 5.35154 4.15625 7.77033V11.875C4.15625 12.5298 3.62354 13.0625 2.96875 13.0625C2.64085 13.0625 2.375 13.3284 2.375 13.6562V16.0312C2.375 16.3591 2.64085 16.625 2.96875 16.625H7.44321C7.42933 16.7226 7.42188 16.8216 7.42188 16.9219C7.42188 18.0677 8.35414 19 9.5 19C10.6459 19 11.5781 18.0677 11.5781 16.9219C11.5781 16.8216 11.5707 16.7226 11.5568 16.625H16.0312C16.3591 16.625 16.625 16.3591 16.625 16.0312V13.6562C16.625 13.3284 16.3591 13.0625 16.0312 13.0625ZM9.5 1.1875C9.82738 1.1875 10.0938 1.45387 10.0938 1.78125C10.0938 2.10863 9.82738 2.375 9.5 2.375C9.17262 2.375 8.90625 2.10863 8.90625 1.78125C8.90625 1.45387 9.17262 1.1875 9.5 1.1875ZM10.3906 16.9219C10.3906 17.413 9.99111 17.8125 9.5 17.8125C9.00889 17.8125 8.60938 17.413 8.60938 16.9219C8.60938 16.8193 8.62652 16.7193 8.65988 16.625H10.3401C10.3735 16.7193 10.3906 16.8193 10.3906 16.9219ZM15.4375 15.4375H10.6875H8.3125H3.5625V14.1749C4.58572 13.9106 5.34375 12.9796 5.34375 11.875V7.77033C5.34375 5.45816 7.20152 3.57055 9.48504 3.56254C9.49009 3.56254 9.49507 3.5625 9.50007 3.5625C10.6076 3.5625 11.6489 3.99263 12.4337 4.77468C13.2221 5.56028 13.6562 6.60588 13.6562 7.71875V11.875C13.6562 12.9796 14.4143 13.9106 15.4375 14.1749V15.4375Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16.5,
  cy: 2.5,
  r: 2.5,
  fill: "#FF6565"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_9652:359"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 19,
  fill: "white"
})));

var SvgNotificationNew = function SvgNotificationNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotificationNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification-new.c7ebdd20.svg";
export { ForwardRef as ReactComponent };